export default "__VITE_ASSET__CFZy_jfc__"